const Place = {
    elemName: '場所',
    type: 'inline',
    doc: '場所情報をマークアップします。',
    example: '〔日本橋〕',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Place {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<placeName {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</placeName>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$text}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
export default Place;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGxhY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9QbGFjZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLEtBQUssR0FBbUI7SUFDN0IsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxpQkFBaUI7SUFDdEIsT0FBTyxFQUFFLE9BQU87SUFDaEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLGdFQUFnRTtJQUM5RSxXQUFXLEVBQUUsaUVBQWlFO0lBQzlFLFlBQVksRUFBRSw2RUFBNkU7SUFDM0YsYUFBYSxFQUFFLFdBQVc7Q0FDMUIsQ0FBQztBQUVGLGVBQWUsS0FBSyxDQUFDIn0=